import React, { useState } from 'react';
import './PhotoGallery.css';

const PhotoGallery = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [lightboxPhotos, setLightboxPhotos] = useState([]);
  const [expanded, setExpanded] = useState({ people: false, scenic: false });

  const peoplePhotos = [
    { src: 'https://i.pinimg.com/736x/64/11/fb/6411fb3e0dcf537cb829cf1f671ac7c9.jpg'},
    { src: 'https://i.pinimg.com/736x/e3/bc/44/e3bc44ee203b27805ced39814de82640.jpg', alt: 'Friends exploring an ancient fort' },
    { src: 'https://i.pinimg.com/736x/b9/e7/43/b9e743f6ac55723f8cef65ef97c6b9c2.jpg', alt: 'Travelers enjoying beach sunset' },
    { src: 'https://i.pinimg.com/736x/f9/e4/70/f9e470cd3ca0d4d54e0bee2a59a45baa.jpg', alt: 'Hikers cheering at a mountain viewpoint' },
    { src: 'https://i.pinimg.com/736x/03/3f/2a/033f2aec3c05bfc0eea06d02d8b63324.jpg', alt: 'Group on a jeep safari in the desert' },
    { src: 'https://i.pinimg.com/736x/48/57/03/48570361a106c91e1a2f6a7bf39ec044.jpg', alt: 'Backpacking buddies on a trail' },
    { src: 'https://i.pinimg.com/736x/c2/43/96/c24396ab96105b587b085c8c107915c5.jpg', alt: 'Friends at a tropical cove' },
    { src: 'https://i.pinimg.com/736x/a3/00/89/a300894f66d69dadba81d1e0733d2426.jpg'},
    { src: 'https://i.pinimg.com/736x/50/1f/0c/501f0cb2115ef6fb0db9dbd76f702625.jpg'},
    { src: 'https://i.pinimg.com/736x/ec/84/5a/ec845a5b1e1e3f072a4e5efa737e20b6.jpg'},
  ];

  const scenicPhotos = [
    { src: 'https://i.pinimg.com/736x/ad/35/30/ad35307e343970cfe552cb6cb469c07b.jpg', alt: 'Kashi Vishwanath temple Banaras' },
    { src: 'https://i.pinimg.com/736x/8b/3f/01/8b3f019521e363035da9b2e1537056b4.jpg', alt: 'Mussorie sunset' },
    { src: 'https://i.pinimg.com/736x/d7/c9/1c/d7c91c1f651293d472b6a9b8c11187ed.jpg', alt: 'House of himachal pradesh' },
    { src: 'https://i.pinimg.com/736x/d6/de/79/d6de79ec162edb670d1088a35bbd972e.jpg', alt: 'Golden Temple lights' },
    { src: 'https://i.pinimg.com/1200x/41/93/29/419329c9280a5c3819436ae75aa43be6.jpg', alt: 'Sadhus at ghats' },
    { src: 'https://i.pinimg.com/1200x/3a/73/05/3a7305d495bc9475151ad4f3db7a5150.jpg', alt: 'Taj Mahal of agra' },
    { src: 'https://i.pinimg.com/736x/6c/b2/b9/6cb2b95940c1c82fe8cea016dd7f46f4.jpg', alt: 'Jibhi' },
    { src: 'https://i.pinimg.com/736x/da/92/e0/da92e0b4368612c38e83a0bce045e703.jpg', alt: 'Kedarntah temple' },
    { src: 'https://i.pinimg.com/736x/06/68/ca/0668ca07984cf7d64e54d3a377f18322.jpg', alt: 'Chopta valley starting of tungnath trek' },
    { src: 'https://i.pinimg.com/736x/16/9e/c6/169ec6f7e5b2176dfbea368710fc88a4.jpg', alt: 'Devprayag sangam origin of maa ganga' },
    { src: 'https://i.pinimg.com/474x/4c/a1/7c/4ca17c87967e46de846aea3b900bf14c.jpg', alt: 'Parimarth niketan rishikesh' },
    { src: 'https://i.pinimg.com/736x/56/76/50/567650a7c3773eeb1823c285b9357546.jpg', alt: 'Ayodha nagri land of lord RAM' }
  ];

  const openLightbox = (photos, index) => {
    setLightboxPhotos(photos);
    setActiveIndex(index);
  };

  const closeModal = () => setActiveIndex(null);
  const showPrev = (e) => {
    e.stopPropagation();
    setActiveIndex((prev) => (prev === 0 ? lightboxPhotos.length - 1 : prev - 1));
  };
  const showNext = (e) => {
    e.stopPropagation();
    setActiveIndex((prev) => (prev === lightboxPhotos.length - 1 ? 0 : prev + 1));
  };

  const renderBlock = (title, key, photos) => {
    const isExpanded = expanded[key];
    const visible = isExpanded ? photos : photos.slice(0, 3);
    const remainingCount = photos.length - 3;

    return (
      <div className="gallery-block">
        <div className="gallery-header">
          <h3>{title}</h3>
          {photos.length > 3 && (
            <button
              className="toggle-view"
              onClick={() => setExpanded((p) => ({ ...p, [key]: !p[key] }))}
            >
              {isExpanded ? 'Show less' : `View more (${remainingCount})`}
            </button>
          )}
        </div>

        <div className="gallery-grid">
          {visible.map((photo, index) => {
            const isThirdWithMore = !isExpanded && index === 2 && photos.length > 3;
            return (
              <div key={index} className="gallery-item-wrapper">
                <button
                  className="gallery-item"
                  onClick={() => openLightbox(photos, index)}
                  aria-label={`Open ${photo.alt}`}
                >
                  <img src={photo.src} alt={photo.alt} />
                </button>
                {isThirdWithMore && (
                  <button
                    className="more-overlay"
                    onClick={() => setExpanded((p) => ({ ...p, [key]: true }))}
                    aria-label={`View more ${title.toLowerCase()}`}
                  >
                    <span className="plus">+</span>
                    <span className="text">View more</span>
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <section className="section photo-gallery" id="packages">
      <div className="container">
        <div className="section-title">
          <h2 className="section-heading">Photo Gallery</h2>
          <p className="section-sub">Explore memories with our travellers and breathtaking landscapes.</p>
        </div>

        {renderBlock('People & Groups', 'people', peoplePhotos)}
        {renderBlock('Scenic Views', 'scenic', scenicPhotos)}
      </div>

      {activeIndex !== null && (
        <div className="lightbox" onClick={closeModal}>
          <button className="lightbox-close" onClick={closeModal} aria-label="Close">&times;</button>
          <button className="lightbox-nav prev" onClick={showPrev} aria-label="Previous">&#10094;</button>
          <img className="lightbox-img" src={lightboxPhotos[activeIndex].src} alt={lightboxPhotos[activeIndex].alt} />
          <div className="lightbox-caption">{lightboxPhotos[activeIndex].alt}</div>
          <button className="lightbox-nav next" onClick={showNext} aria-label="Next">&#10095;</button>
        </div>
      )}
    </section>
  );
};

export default PhotoGallery;
